const BASE_LOGIN_EVENT = {
    category: 'user_accounts',
    action: 'login',
    label: undefined,
    property: {},
    value: undefined,
};

function createLogInEvent({
    provider, method, interaction, email, success, auto = false,
}) {
    if (email) {
        email = email.toLowerCase();
    }

    return {
        ...BASE_LOGIN_EVENT,
        label: provider || 'cognito',
        property: {
            auto,
            method,
            interaction,
            email: email || null,
            success,
        },
    };
}

const BASE_SIGNUP_EVENT = {
    category: 'user_accounts',
    action: 'create_account',
    label: undefined,
    property: {},
    value: undefined,
};

function createSignUpEvent({ provider, email, success }) {
    if (email) {
        email = email.toLowerCase();
    }
    return {
        ...BASE_SIGNUP_EVENT,
        label: provider || 'cognito',
        property: {
            email: email || null,
            success,
        },
    };
}

export default {
    createLogInEvent,
    createSignUpEvent,
};
